import styled from 'styled-components';

export const Content = styled.div`
  width: 496px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  margin-top: 136px;

  > p {
    font-size: 18px;
    margin-top: 24px;
    margin-bottom: 32px;
  }

  @media (max-width: 650px) {
    width: 100%;
    align-items: center;
    margin-top: 48px;

    > p {
      text-align: center;
      margin-top: 16px;
      margin-bottom: 32px;
    }
  }
`;

export const StyleTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;

  > h1 {
    margin-left: 40px;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 39px;
  }

  > p {
    margin-top: 54px;
    font-size: 18px;
  }
`;
